import { useCV } from '../hooks/useCV'
import Section from './Section'

const Projects = () => {
  const { projects } = useCV()

  return (
    <Section id="projects" title="Projects">
      <ul>
        {projects.map((project) => (
          <li
            key={project.title}
            className="grid md:grid-cols-12 gap-x-8 gap-y-2 py-8 border-b border-rule first:pt-0 last:border-b-0"
          >
            <h3 className="md:col-span-4 font-serif text-2xl font-medium leading-tight">{project.title}</h3>
            <div className="md:col-span-8">
              <p className="leading-relaxed">{project.description}</p>
              <p className="mt-3 text-sm text-mute">{project.technologies.join(', ')}</p>
              {(project.demo || project.github) && (
                <p className="mt-3 flex gap-5 text-sm font-medium">
                  {project.demo && (
                    <a href={project.demo} target="_blank" rel="noopener noreferrer" className="text-accent underline underline-offset-4 hover:no-underline">
                      Visit {project.demo.replace(/^https?:\/\/(www\.)?/, '')}
                    </a>
                  )}
                  {project.github && (
                    <a href={project.github} target="_blank" rel="noopener noreferrer" className="text-accent underline underline-offset-4 hover:no-underline">
                      Source code
                    </a>
                  )}
                </p>
              )}
            </div>
          </li>
        ))}
      </ul>
    </Section>
  )
}

export default Projects
